var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6811 18.5256L23.6811 4.17445L28.4648 4.17445L28.4648 18.5256L23.6811 18.5256ZM18.8974 4.17445C19.5318 4.17445 20.1402 4.42645 20.5887 4.87501C21.0373 5.32357 21.2893 5.93195 21.2893 6.56631L21.2893 18.5256C21.2893 19.1834 21.0262 19.7813 20.5837 20.2118L12.7145 28.093L11.4468 26.8253C11.1239 26.5024 10.9206 26.0599 10.9206 25.5696L10.9565 25.1869L12.0926 19.7215L4.54628 19.7215C3.91192 19.7215 3.30354 19.4695 2.85498 19.021C2.40642 18.5724 2.15442 17.964 2.15442 17.3297L2.15442 14.9378C2.15442 14.6269 2.21422 14.3398 2.32185 14.0648L5.93356 5.63348C6.29234 4.77242 7.14145 4.17445 8.13407 4.17445L18.8974 4.17445ZM18.8974 6.56631L8.09819 6.56631L4.54628 14.9378L4.54628 17.3297L15.0585 17.3297L13.7071 23.692L18.8974 18.4897L18.8974 6.56631Z",
    fill: "#7C42EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislike);
export default __webpack_public_path__ + "static/media/dislike.9d7629d2ea77e0a14c582342c66c39ef.svg";
export { ForwardRef as ReactComponent };